import React from 'react';

import PropTypes from 'prop-types';

import PromoPopupButton from '../../popup/PromoPopupButton';
import PromoSimplePopup from '../../popup/PromoSimplePopup';

const ErrorPopup = (props) => {
    return (
        <PromoSimplePopup text={props.text} popupRef={props.popupRef}>
            <PromoPopupButton
                iconName={'check'}
                text={props.btnText}
                onClick={(e) => {
                    e.preventDefault();
                    props.popupRef.current?.close();
                }}
            />
        </PromoSimplePopup>
    );
};

ErrorPopup.propTypes = {
    text: PropTypes.string,
    btnText: PropTypes.string,
};

export default ErrorPopup;
